






































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class TextAlignPicker extends Vue {
  @Prop({ default: "left" }) value!: string;

  @Emit("change")
  handleChange(value: string) {
    return value;
  }

  @Emit("input")
  handleInput(value: string) {
    return value;
  }

  handleSelect(value: string) {
    this.handleChange(value);
    this.handleInput(value);
  }
}
